import React, { useState } from 'react';
import Styled from '../styles/AdminFVContainer.styled';
import { useHistory } from 'react-router-dom';
import { isArray } from 'lodash';
import { ToastError, ToastSuccess } from 'components/Toaster';
import { bucketS3, caminhoAnexosGeneralFiles } from 'constants/EnvironmentData';
import { useSolutions } from '../hooks/solutions/useSolutions';
import FormFerramentaVideo from '../components/FormFerramentaVideo';
import FVActionButtons from '../components/FVActionsButton';
import TipoSolucoesDTO from 'models/solucoes/TipoSolucoesDTO';
import { useFetchFVContainer } from '../hooks/FVContainer/useFetchFVContainer';
import { set } from 'js-cookie';

const AdminFVContainer = () => {
    const history = useHistory();
    const [formVisible, setFormVisible] = useState(false);
    const { createContainerMutation, listQuery, updateContainerMutation, deleteContainerMutation } = useFetchFVContainer();
    const { listQuerySolutions } = useSolutions();
    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState<{
        id: number;
        title: string;
        description: string;
        url: string;
        altUrl: string;
        codigoSolucao: any; // Use 'any' or 'TipoSolucoesDTO | null' if you have the type imported
        notAccessibility?: boolean;
    }>({
        id: -1,
        title: '',
        description: '',
        url: '',
        altUrl: '',
        codigoSolucao: null,
        notAccessibility: false,
    });

    // Exemplo de opções de soluções

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        // Não extraia apenas o id, envie o objeto completo
        const solucao =
            form.codigoSolucao != null
                ? ((typeof form.codigoSolucao === 'number'
                      ? listQuerySolutions?.data?.filter(solucao => solucao.id === form.codigoSolucao)[0] || null
                      : listQuerySolutions?.data?.filter(solucao => solucao.id === form.codigoSolucao.id)[0] || null) as TipoSolucoesDTO | null)
                : null;

        if (form.id > 0) {
            updateContainerMutation.mutate(
                {
                    id: form.id,
                    title: form.title,
                    description: form.description,
                    url: form.url.toLowerCase(),
                    altUrl: form.altUrl,
                    codigoSolucao: solucao, // Envie o objeto completo ou null
                    notAccessibility: form.notAccessibility || false,
                },
                {
                    onSuccess: () => {
                        ToastSuccess('Ferramenta de vídeo atualizada com sucesso!');
                        setForm({ id: -1, title: '', description: '', url: '', altUrl: '', codigoSolucao: null });
                        setFormVisible(false);
                        setLoading(false);
                    },
                    onError: () => {
                        ToastError('Erro ao atualizar ferramenta de vídeo, verifique as informações e tente novamente.');
                        setLoading(false);
                    },
                    
                }
            );
        } else {
            createContainerMutation.mutate(
                {
                    title: form.title,
                    description: form.description,
                    url: form.url.toLowerCase(),
                    altUrl: form.altUrl,
                    codigoSolucao: solucao, // Envie o objeto completo
                },
                {
                    onSuccess: () => {
                        ToastSuccess('Ferramenta de vídeo criada com sucesso!');
                        setForm({ id: -1, title: '', description: '', url: '', altUrl: '', codigoSolucao: null });
                        setFormVisible(false);
                        setLoading(false);
                    },
                    onError: () => {
                        ToastError('Erro ao criar ferramenta de vídeo, verifique as informações e tente novamente.');
                        setLoading(false);
                    },
                }
            );
        }
        // Chama a mutation para criar ferramenta de vídeo
    };

    const handleDelete = (id: number) => {
        deleteContainerMutation.mutate(id, {
            onSuccess: () => {
                ToastSuccess('Ferramenta de vídeo excluída com sucesso!');
            },
            onError: () => {
                ToastError('Erro ao excluir ferramenta de vídeo, tente novamente.');
            },
        });
    };

    const handleEditForm = (formData: any) => {
        setForm(formData);
        setFormVisible(true);
    };

    const getS3BaseUrl = (): string => {
        return bucketS3() + caminhoAnexosGeneralFiles();
    };

    const goToContainer = (id: number) => {
        history.push(`/admin/ferramenta-video/${id}`);
    };

    const resetForm = () => {
        setForm({
            id: -1,
            title: '',
            description: '',
            url: '',
            altUrl: '',
            codigoSolucao: null,
        });
        setFormVisible(false);
    };

    return (
        <section>
            <Styled.Button
                onClick={() => {
                    setFormVisible(true);
                    window.scrollTo(0, 0);
                }}
            >
                Criar ferramenta de video
            </Styled.Button>

            <FormFerramentaVideo
                form={form}
                setForm={setForm}
                formVisible={formVisible}
                setFormVisible={resetForm}
                handleSubmit={handleSubmit}
                listQuerySolutions={listQuerySolutions.data || []}
                handleChange={handleChange}
                loading={loading}
            />
            <div style={{ minHeight: '620px' }}>
                {listQuery.isLoading && (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%',
                            gap: '1rem',
                        }}
                    >
                        <div className="loaderConteudo" style={{ width: '100px' }} />
                        <h1>Carregando os conteúdos ...</h1>
                    </div>
                )}

                {listQuery.isSuccess && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
                        {isArray(listQuery.data) && listQuery.data.length > 0 ? (
                            listQuery.data.map(item => (
                                <section
                                    key={item.id}
                                    style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}
                                >
                                    <Styled.Card.Container onClick={() => goToContainer(item.id)}>
                                        {item.codigoSolucao ? (
                                            <img src={getS3BaseUrl() + item.codigoSolucao.logo} alt={item.title} />
                                        ) : (
                                            <img
                                                src={
                                                    getS3BaseUrl() + 'anexo_storage_files_14914931168902942885.png_2025-08-27-1756305513467.png'
                                                }
                                                alt="Imagem logo Humane"
                                            />
                                        )}
                                        <h1>{item.title}</h1>
                                        <p>URL: /{item.url}</p>
                                    </Styled.Card.Container>
                                    <FVActionButtons
                                        onDelete={() => handleDelete(item.id)}
                                        onEdit={() => handleEditForm(item)}
                                        msgDelete="Tem certeza que deseja deletar esta ferramenta?"
                                    />
                                </section>
                            ))
                        ) : (
                            <div>Nenhum conteúdo encontrado.</div>
                        )}
                    </div>
                )}
            </div>
        </section>
    );
};

export default AdminFVContainer;
